import { z } from 'zod';
const denyVolunteeringHoursParamsSchema = z.object({
    participationId: z.string().uuid(),
    status: z.enum(['deniedInaccurate', 'deniedNoShow']),
    missionTypeId: z.string().uuid(),
});
export const denyVolunteeringHoursFunctionDef = {
    name: 'denyVolunteeringHours',
    requestSchema: denyVolunteeringHoursParamsSchema,
    responseSchema: z.void(),
};
